import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAdminSlot } from '../../../../assets/types/dtoTypes';

export type SlotAction = 'toggle' | 'delete';

@Component({
  selector: 'app-slot-actions-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slot-actions-modal.component.html',
  styleUrls: ['./slot-actions-modal.component.scss'],
})
export class SlotActionsModalComponent {
  private dialogRef = inject(MatDialogRef<SlotActionsModalComponent>);
  data = inject<{ slot: IAdminSlot }>(MAT_DIALOG_DATA);

  get slot(): IAdminSlot {
    return this.data.slot;
  }

  close(): void {
    this.dialogRef.close();
  }

  emit(action: SlotAction): void {
    this.dialogRef.close(action);
  }
}
